import {Product} from 'types';

export enum ProductCardVariant {
  LEO = 'leo',
  COMPACT = 'compact',
  TOPPICKS = 'topPicks',
  ADS = 'ads'
}

export type ProductStatusProps = {
  status?: string;
  isPDP?: boolean;
  product?: Product;
  productCardVariant?: ProductCardVariant;
};
